// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CGMInfoItem-module__font-s-10___a5i5I {
  font-size: 10px !important;
}

.CGMInfoItem-module__font-s-12___ajgLD {
  font-size: 12px !important;
}

.CGMInfoItem-module__font-s-13___bgC32 {
  font-size: 13px !important;
}

.CGMInfoItem-module__font-s-14___WTqly {
  font-size: 14px !important;
}

.CGMInfoItem-module__font-s-15___muVZG {
  font-size: 15px !important;
}

.CGMInfoItem-module__font-s-16___vbdNl {
  font-size: 16px !important;
}

.CGMInfoItem-module__font-s-18___DfSsY {
  font-size: 18px !important;
}

.CGMInfoItem-module__font-s-20___fHS41 {
  font-size: 20px !important;
}

.CGMInfoItem-module__font-s-22___C4XsB {
  font-size: 22px !important;
}

.CGMInfoItem-module__font-s-28___hBege {
  font-size: 28px !important;
}

.CGMInfoItem-module__font-w-400___dUmO4 {
  font-weight: 400 !important;
}

.CGMInfoItem-module__font-w-500___oqs2h {
  font-weight: 500 !important;
}

.CGMInfoItem-module__font-w-600___KkfkO {
  font-weight: 600 !important;
}

.CGMInfoItem-module__font-w-700___fZXNs {
  font-weight: 700 !important;
}

.CGMInfoItem-module__p-5___o5PX3 {
  padding: 5px !important;
}

.CGMInfoItem-module__p-12___MFlnb {
  padding: 12px !important;
}

.CGMInfoItem-module__p-16___Be9O0 {
  padding: 16px !important;
}

.CGMInfoItem-module__p-30___Z0v90 {
  padding: 30px !important;
}

.CGMInfoItem-module__p-b-0___dXtnR {
  padding-bottom: 0 !important;
}

.CGMInfoItem-module__p-b-5___yyBLf {
  padding-bottom: 5px !important;
}

.CGMInfoItem-module__p-b-10___GxTY_ {
  padding-bottom: 10px !important;
}

.CGMInfoItem-module__p-b-12___cgFSi {
  padding-bottom: 12px !important;
}

.CGMInfoItem-module__p-b-16___AkXlg {
  padding-bottom: 16px !important;
}

.CGMInfoItem-module__p-b-18___dbHkJ {
  padding-bottom: 18px !important;
}

.CGMInfoItem-module__p-b-20___cnL4s {
  padding-bottom: 20px !important;
}

.CGMInfoItem-module__p-b-25___NNRPD {
  padding-bottom: 25px !important;
}

.CGMInfoItem-module__p-b-30___tnm0w {
  padding-bottom: 30px !important;
}

.CGMInfoItem-module__p-b-50___ebkVb {
  padding-bottom: 50px !important;
}

.CGMInfoItem-module__p-t-0___m09bY {
  padding-top: 0 !important;
}

.CGMInfoItem-module__p-t-12___FOUYY {
  padding-top: 12px !important;
}

.CGMInfoItem-module__p-t-16___fczLQ {
  padding-top: 16px !important;
}

.CGMInfoItem-module__p-t-18___l35eF {
  padding-top: 18px !important;
}

.CGMInfoItem-module__p-t-20___ZWJgr {
  padding-top: 20px !important;
}

.CGMInfoItem-module__p-t-30___tXF8z {
  padding-top: 30px !important;
}

.CGMInfoItem-module__p-t-40___J44DW {
  padding-top: 40px !important;
}

.CGMInfoItem-module__p-t-50___N9LUN {
  padding-top: 50px !important;
}

.CGMInfoItem-module__p-l-20___wv16c {
  padding-left: 20px !important;
}

.CGMInfoItem-module__p-l-30___gvQlO {
  padding-left: 30px !important;
}

.CGMInfoItem-module__p-l-40___TQdYN {
  padding-left: 40px !important;
}

.CGMInfoItem-module__p-r-16___m5O_3 {
  padding-right: 16px !important;
}

.CGMInfoItem-module__p-r-20___a3xvJ {
  padding-right: 20px !important;
}

.CGMInfoItem-module__p-r-30___AaLK4 {
  padding-right: 30px !important;
}

.CGMInfoItem-module__p-r-50___aNmyQ {
  padding-right: 50px !important;
}

.CGMInfoItem-module__p-r-60___yQIkA {
  padding-right: 60px !important;
}

.CGMInfoItem-module__m-b-1___jjonn {
  margin-bottom: 1px !important;
}

.CGMInfoItem-module__m-b-2___PlPg7 {
  margin-bottom: 2px !important;
}

.CGMInfoItem-module__m-b-6___fcmqM {
  margin-bottom: 6px !important;
}

.CGMInfoItem-module__m-b-8___rdSNy {
  margin-bottom: 8px !important;
}

.CGMInfoItem-module__m-b-10___nwIe_ {
  margin-bottom: 10px !important;
}

.CGMInfoItem-module__m-b-14___S6mg7 {
  margin-bottom: 14px !important;
}

.CGMInfoItem-module__m-b-16___yjz8T {
  margin-bottom: 16px !important;
}

.CGMInfoItem-module__m-b-20___rahUw {
  margin-bottom: 20px !important;
}

.CGMInfoItem-module__m-b-22___Ay4So {
  margin-bottom: 22px !important;
}

.CGMInfoItem-module__m-b-24___XKo8D {
  margin-bottom: 24px !important;
}

.CGMInfoItem-module__m-b-30___u91r6 {
  margin-bottom: 30px !important;
}

.CGMInfoItem-module__m-b-32___GSAEi {
  margin-bottom: 32px !important;
}

.CGMInfoItem-module__m-b-40___wA8Sg {
  margin-bottom: 40px !important;
}

.CGMInfoItem-module__m-t-2___BFV15 {
  margin-top: 2px !important;
}

.CGMInfoItem-module__m-t-3___X0JSM {
  margin-top: 3px !important;
}

.CGMInfoItem-module__m-t-4___Tll6T {
  margin-top: 4px !important;
}

.CGMInfoItem-module__m-t-5___ymcFM {
  margin-top: 5px !important;
}

.CGMInfoItem-module__m-t-8___qTMZu {
  margin-top: 8px !important;
}

.CGMInfoItem-module__m-t-10___tcukq {
  margin-top: 10px !important;
}

.CGMInfoItem-module__m-t-15___tDQ_I {
  margin-top: 15px !important;
}

.CGMInfoItem-module__m-t-16___iWwxa {
  margin-top: 16px !important;
}

.CGMInfoItem-module__m-t-20___EB_j0 {
  margin-top: 20px !important;
}

.CGMInfoItem-module__m-t-22___cZUNO {
  margin-top: 22px !important;
}

.CGMInfoItem-module__m-t-30___Z6iPh {
  margin-top: 30px !important;
}

.CGMInfoItem-module__m-t-32___tLN7V {
  margin-top: 32px !important;
}

.CGMInfoItem-module__m-l-auto___DA7nM {
  margin-left: auto !important;
}

.CGMInfoItem-module__m-l-4___Vaaej {
  margin-left: 4px !important;
}

.CGMInfoItem-module__m-l-5___ecTTw {
  margin-left: 5px !important;
}

.CGMInfoItem-module__m-l-6___e96VT {
  margin-left: 6px !important;
}

.CGMInfoItem-module__m-l-8___QBnqG {
  margin-left: 8px !important;
}

.CGMInfoItem-module__m-l-10___gGejo {
  margin-left: 10px !important;
}

.CGMInfoItem-module__m-l-16___M7LRS {
  margin-left: 16px !important;
}

.CGMInfoItem-module__m-l-20___MaBwo {
  margin-left: 20px !important;
}

.CGMInfoItem-module__m-l-24___izi5k {
  margin-left: 24px !important;
}

.CGMInfoItem-module__m-l-30___Zq7v_ {
  margin-left: 30px !important;
}

.CGMInfoItem-module__m-l-35___Qu3yA {
  margin-left: 35px !important;
}

.CGMInfoItem-module__m-l-40___WepVB {
  margin-left: 40px !important;
}

.CGMInfoItem-module__m-r-8___sREOt {
  margin-right: 8px !important;
}

.CGMInfoItem-module__m-r-10___V4Gjq {
  margin-right: 10px !important;
}

.CGMInfoItem-module__m-r-16___y0s82 {
  margin-right: 16px !important;
}

.CGMInfoItem-module__m-r-20___WyfOM {
  margin-right: 20px !important;
}

.CGMInfoItem-module__m-r-24___VhLUh {
  margin-right: 24px !important;
}

.CGMInfoItem-module__m-r-30___QMtVO {
  margin-right: 30px !important;
}

.CGMInfoItem-module__m-r-40___Ut5wG {
  margin-right: 40px !important;
}

.CGMInfoItem-module__border-r-3___TUPv7 {
  border-radius: 3px !important;
}

.CGMInfoItem-module__border-r-4___F0ef_ {
  border-radius: 4px !important;
}

.CGMInfoItem-module__border-r-6___Q4Co0 {
  border-radius: 6px !important;
}

.CGMInfoItem-module__border-r-10___NkUXd {
  border-radius: 10px !important;
}

.CGMInfoItem-module__border-r-12___B91Lq {
  border-radius: 12px !important;
}

.CGMInfoItem-module__border-r-16___IWpxg {
  border-radius: 16px !important;
}

.CGMInfoItem-module__border-r-50____XuVL {
  border-radius: 50% !important;
}

.CGMInfoItem-module__primary-border___imsbR {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMInfoItem-module__primary-border-b___Q876W {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMInfoItem-module__primary-border-t___Ht8ff {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMInfoItem-module__primary-border-l___ZJ875 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMInfoItem-module__primary-border-r___pj_Uj {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.CGMInfoItem-module__secondary-border___uJrXa {
  border: 1px solid #637768;
}

.CGMInfoItem-module__secondary-border-b___hS7mm {
  border-bottom: 1px solid #637768;
}

.CGMInfoItem-module__secondary-border-t___REgCO {
  border-top: 1px solid #637768;
}

.CGMInfoItem-module__secondary-border-l___Qejnr {
  border-left: 1px solid #637768;
}

.CGMInfoItem-module__secondary-border-r___RYRjK {
  border-right: 1px solid #637768;
}

.CGMInfoItem-module__gap-0___uM9hS {
  gap: 0 !important;
}

.CGMInfoItem-module__gap-2___ECk1G {
  gap: 2px !important;
}

.CGMInfoItem-module__gap-4___k6SkW {
  gap: 4px !important;
}

.CGMInfoItem-module__gap-5___Nv9e0 {
  gap: 5px !important;
}

.CGMInfoItem-module__gap-6___EEdBz {
  gap: 6px !important;
}

.CGMInfoItem-module__gap-8___ReU1S {
  gap: 8px !important;
}

.CGMInfoItem-module__gap-10___GE3I7 {
  gap: 10px !important;
}

.CGMInfoItem-module__gap-12___GQ6hw {
  gap: 12px !important;
}

.CGMInfoItem-module__gap-14___ko9Io {
  gap: 14px !important;
}

.CGMInfoItem-module__gap-16___yepq0 {
  gap: 16px !important;
}

.CGMInfoItem-module__gap-18___baAVg {
  gap: 18px !important;
}

.CGMInfoItem-module__gap-20___JlrhO {
  gap: 20px !important;
}

.CGMInfoItem-module__gap-24___BL9Zf {
  gap: 24px !important;
}

.CGMInfoItem-module__gap-26___tWdG6 {
  gap: 26px !important;
}

.CGMInfoItem-module__gap-30____vByp {
  gap: 30px !important;
}

.CGMInfoItem-module__gap-32___L6kTu {
  gap: 32px !important;
}

.CGMInfoItem-module__gap-40___y2qZo {
  gap: 40px !important;
}

.CGMInfoItem-module__gap-50___bd8nq {
  gap: 50px !important;
}

.CGMInfoItem-module__flex-1___NSGHb {
  flex: 1;
}

.CGMInfoItem-module__flex-none___BgEhq {
  flex: none !important;
}

.CGMInfoItem-module__flex-column___j1T5H {
  display: flex;
  flex-direction: column !important;
}

.CGMInfoItem-module__flex-row___gDLQ0 {
  display: flex;
  flex-direction: row !important;
}

.CGMInfoItem-module__vertically-centered___cN6nw {
  display: flex;
  align-items: center !important;
}

.CGMInfoItem-module__horizontally-centered___moAsh {
  display: flex;
  justify-content: center !important;
}

.CGMInfoItem-module__horizontally-end___O5AgL {
  display: flex;
  justify-content: end !important;
}

.CGMInfoItem-module__vertically-start___Hi19K {
  display: flex;
  align-items: start !important;
}

.CGMInfoItem-module__space-between___w19tk {
  display: flex;
  justify-content: space-between !important;
}

.CGMInfoItem-module__flex-wrap___JZZYW {
  flex-wrap: wrap !important;
}

.CGMInfoItem-module__height-100___Qw8zy {
  height: 100%;
}

.CGMInfoItem-module__width-50____teyt {
  width: 50% !important;
}

.CGMInfoItem-module__width-100___bz6Q1 {
  width: 100%;
}

.CGMInfoItem-module__cursor-pointer___oX3FN {
  cursor: pointer;
}

.CGMInfoItem-module__cursor-not-allowed___S8Zbl {
  cursor: not-allowed !important;
}

.CGMInfoItem-module__absolute-centered___IkQWl {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.CGMInfoItem-module__absolute___KgVGG {
  position: absolute;
}

.CGMInfoItem-module__relative___skScp {
  position: relative;
}

.CGMInfoItem-module__fixed___dZSG6 {
  position: fixed;
}

.CGMInfoItem-module__visible___aliIS {
  opacity: 1;
}

.CGMInfoItem-module__invisible___NGUPH {
  opacity: 0;
}

.CGMInfoItem-module__col-90___YLmOq {
  width: 90% !important;
}

.CGMInfoItem-module__col-auto___qUwpQ {
  width: auto !important;
}

.CGMInfoItem-module__medical-tabs___whDeS {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.CGMInfoItem-module__medical-table-new___TzN_t {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMInfoItem-module__medical-table-new___TzN_t:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMInfoItem-module__medical-table-new___TzN_t::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMInfoItem-module__medical-table-new___TzN_t::-webkit-scrollbar-track {
  display: none;
}
.CGMInfoItem-module__medical-table-new___TzN_t.CGMInfoItem-module__no-pagination___XfJCA {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.CGMInfoItem-module__medical-table-new___TzN_t.CGMInfoItem-module__no-pagination___XfJCA:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.CGMInfoItem-module__medical-table-new___TzN_t.CGMInfoItem-module__no-pagination___XfJCA::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.CGMInfoItem-module__medical-table-new___TzN_t.CGMInfoItem-module__no-pagination___XfJCA::-webkit-scrollbar-track {
  display: none;
}

.CGMInfoItem-module__medical-table-empty___bNXa8 {
  padding: 14px 40px !important;
}

.CGMInfoItem-module__icon-btn___ZqOuf {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.CGMInfoItem-module__search-icon___vLaNb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.CGMInfoItem-module__disable-select___sCJnn {
  user-select: none;
}

.CGMInfoItem-module__break-word___fm4tF {
  word-break: break-word;
}

.CGMInfoItem-module__popup-clear-btn___XDLTJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.CGMInfoItem-module__scroll-m-b-20___UTGsi {
  scroll-margin-bottom: 20px;
}

.CGMInfoItem-module__wrapper___d9Ub6 {
  flex: 0 1 50%;
}
.CGMInfoItem-module__wrapper___d9Ub6 > div {
  width: auto;
}
.CGMInfoItem-module__wrapper___d9Ub6 .CGMInfoItem-module__title___DEvJ9 {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Biometrics/items/CGMInfoItem/CGMInfoItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;AA8pBF;AA5pBE;EACE,WAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  flex: 0 1 50%;\n\n  & > div {\n    width: auto;\n  }\n\n  .title {\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `CGMInfoItem-module__font-s-10___a5i5I`,
	"fontS12": `CGMInfoItem-module__font-s-12___ajgLD`,
	"fontS13": `CGMInfoItem-module__font-s-13___bgC32`,
	"fontS14": `CGMInfoItem-module__font-s-14___WTqly`,
	"fontS15": `CGMInfoItem-module__font-s-15___muVZG`,
	"fontS16": `CGMInfoItem-module__font-s-16___vbdNl`,
	"fontS18": `CGMInfoItem-module__font-s-18___DfSsY`,
	"fontS20": `CGMInfoItem-module__font-s-20___fHS41`,
	"fontS22": `CGMInfoItem-module__font-s-22___C4XsB`,
	"fontS28": `CGMInfoItem-module__font-s-28___hBege`,
	"fontW400": `CGMInfoItem-module__font-w-400___dUmO4`,
	"fontW500": `CGMInfoItem-module__font-w-500___oqs2h`,
	"fontW600": `CGMInfoItem-module__font-w-600___KkfkO`,
	"fontW700": `CGMInfoItem-module__font-w-700___fZXNs`,
	"p5": `CGMInfoItem-module__p-5___o5PX3`,
	"p12": `CGMInfoItem-module__p-12___MFlnb`,
	"p16": `CGMInfoItem-module__p-16___Be9O0`,
	"p30": `CGMInfoItem-module__p-30___Z0v90`,
	"pB0": `CGMInfoItem-module__p-b-0___dXtnR`,
	"pB5": `CGMInfoItem-module__p-b-5___yyBLf`,
	"pB10": `CGMInfoItem-module__p-b-10___GxTY_`,
	"pB12": `CGMInfoItem-module__p-b-12___cgFSi`,
	"pB16": `CGMInfoItem-module__p-b-16___AkXlg`,
	"pB18": `CGMInfoItem-module__p-b-18___dbHkJ`,
	"pB20": `CGMInfoItem-module__p-b-20___cnL4s`,
	"pB25": `CGMInfoItem-module__p-b-25___NNRPD`,
	"pB30": `CGMInfoItem-module__p-b-30___tnm0w`,
	"pB50": `CGMInfoItem-module__p-b-50___ebkVb`,
	"pT0": `CGMInfoItem-module__p-t-0___m09bY`,
	"pT12": `CGMInfoItem-module__p-t-12___FOUYY`,
	"pT16": `CGMInfoItem-module__p-t-16___fczLQ`,
	"pT18": `CGMInfoItem-module__p-t-18___l35eF`,
	"pT20": `CGMInfoItem-module__p-t-20___ZWJgr`,
	"pT30": `CGMInfoItem-module__p-t-30___tXF8z`,
	"pT40": `CGMInfoItem-module__p-t-40___J44DW`,
	"pT50": `CGMInfoItem-module__p-t-50___N9LUN`,
	"pL20": `CGMInfoItem-module__p-l-20___wv16c`,
	"pL30": `CGMInfoItem-module__p-l-30___gvQlO`,
	"pL40": `CGMInfoItem-module__p-l-40___TQdYN`,
	"pR16": `CGMInfoItem-module__p-r-16___m5O_3`,
	"pR20": `CGMInfoItem-module__p-r-20___a3xvJ`,
	"pR30": `CGMInfoItem-module__p-r-30___AaLK4`,
	"pR50": `CGMInfoItem-module__p-r-50___aNmyQ`,
	"pR60": `CGMInfoItem-module__p-r-60___yQIkA`,
	"mB1": `CGMInfoItem-module__m-b-1___jjonn`,
	"mB2": `CGMInfoItem-module__m-b-2___PlPg7`,
	"mB6": `CGMInfoItem-module__m-b-6___fcmqM`,
	"mB8": `CGMInfoItem-module__m-b-8___rdSNy`,
	"mB10": `CGMInfoItem-module__m-b-10___nwIe_`,
	"mB14": `CGMInfoItem-module__m-b-14___S6mg7`,
	"mB16": `CGMInfoItem-module__m-b-16___yjz8T`,
	"mB20": `CGMInfoItem-module__m-b-20___rahUw`,
	"mB22": `CGMInfoItem-module__m-b-22___Ay4So`,
	"mB24": `CGMInfoItem-module__m-b-24___XKo8D`,
	"mB30": `CGMInfoItem-module__m-b-30___u91r6`,
	"mB32": `CGMInfoItem-module__m-b-32___GSAEi`,
	"mB40": `CGMInfoItem-module__m-b-40___wA8Sg`,
	"mT2": `CGMInfoItem-module__m-t-2___BFV15`,
	"mT3": `CGMInfoItem-module__m-t-3___X0JSM`,
	"mT4": `CGMInfoItem-module__m-t-4___Tll6T`,
	"mT5": `CGMInfoItem-module__m-t-5___ymcFM`,
	"mT8": `CGMInfoItem-module__m-t-8___qTMZu`,
	"mT10": `CGMInfoItem-module__m-t-10___tcukq`,
	"mT15": `CGMInfoItem-module__m-t-15___tDQ_I`,
	"mT16": `CGMInfoItem-module__m-t-16___iWwxa`,
	"mT20": `CGMInfoItem-module__m-t-20___EB_j0`,
	"mT22": `CGMInfoItem-module__m-t-22___cZUNO`,
	"mT30": `CGMInfoItem-module__m-t-30___Z6iPh`,
	"mT32": `CGMInfoItem-module__m-t-32___tLN7V`,
	"mLAuto": `CGMInfoItem-module__m-l-auto___DA7nM`,
	"mL4": `CGMInfoItem-module__m-l-4___Vaaej`,
	"mL5": `CGMInfoItem-module__m-l-5___ecTTw`,
	"mL6": `CGMInfoItem-module__m-l-6___e96VT`,
	"mL8": `CGMInfoItem-module__m-l-8___QBnqG`,
	"mL10": `CGMInfoItem-module__m-l-10___gGejo`,
	"mL16": `CGMInfoItem-module__m-l-16___M7LRS`,
	"mL20": `CGMInfoItem-module__m-l-20___MaBwo`,
	"mL24": `CGMInfoItem-module__m-l-24___izi5k`,
	"mL30": `CGMInfoItem-module__m-l-30___Zq7v_`,
	"mL35": `CGMInfoItem-module__m-l-35___Qu3yA`,
	"mL40": `CGMInfoItem-module__m-l-40___WepVB`,
	"mR8": `CGMInfoItem-module__m-r-8___sREOt`,
	"mR10": `CGMInfoItem-module__m-r-10___V4Gjq`,
	"mR16": `CGMInfoItem-module__m-r-16___y0s82`,
	"mR20": `CGMInfoItem-module__m-r-20___WyfOM`,
	"mR24": `CGMInfoItem-module__m-r-24___VhLUh`,
	"mR30": `CGMInfoItem-module__m-r-30___QMtVO`,
	"mR40": `CGMInfoItem-module__m-r-40___Ut5wG`,
	"borderR3": `CGMInfoItem-module__border-r-3___TUPv7`,
	"borderR4": `CGMInfoItem-module__border-r-4___F0ef_`,
	"borderR6": `CGMInfoItem-module__border-r-6___Q4Co0`,
	"borderR10": `CGMInfoItem-module__border-r-10___NkUXd`,
	"borderR12": `CGMInfoItem-module__border-r-12___B91Lq`,
	"borderR16": `CGMInfoItem-module__border-r-16___IWpxg`,
	"borderR50": `CGMInfoItem-module__border-r-50____XuVL`,
	"primaryBorder": `CGMInfoItem-module__primary-border___imsbR`,
	"primaryBorderB": `CGMInfoItem-module__primary-border-b___Q876W`,
	"primaryBorderT": `CGMInfoItem-module__primary-border-t___Ht8ff`,
	"primaryBorderL": `CGMInfoItem-module__primary-border-l___ZJ875`,
	"primaryBorderR": `CGMInfoItem-module__primary-border-r___pj_Uj`,
	"secondaryBorder": `CGMInfoItem-module__secondary-border___uJrXa`,
	"secondaryBorderB": `CGMInfoItem-module__secondary-border-b___hS7mm`,
	"secondaryBorderT": `CGMInfoItem-module__secondary-border-t___REgCO`,
	"secondaryBorderL": `CGMInfoItem-module__secondary-border-l___Qejnr`,
	"secondaryBorderR": `CGMInfoItem-module__secondary-border-r___RYRjK`,
	"gap0": `CGMInfoItem-module__gap-0___uM9hS`,
	"gap2": `CGMInfoItem-module__gap-2___ECk1G`,
	"gap4": `CGMInfoItem-module__gap-4___k6SkW`,
	"gap5": `CGMInfoItem-module__gap-5___Nv9e0`,
	"gap6": `CGMInfoItem-module__gap-6___EEdBz`,
	"gap8": `CGMInfoItem-module__gap-8___ReU1S`,
	"gap10": `CGMInfoItem-module__gap-10___GE3I7`,
	"gap12": `CGMInfoItem-module__gap-12___GQ6hw`,
	"gap14": `CGMInfoItem-module__gap-14___ko9Io`,
	"gap16": `CGMInfoItem-module__gap-16___yepq0`,
	"gap18": `CGMInfoItem-module__gap-18___baAVg`,
	"gap20": `CGMInfoItem-module__gap-20___JlrhO`,
	"gap24": `CGMInfoItem-module__gap-24___BL9Zf`,
	"gap26": `CGMInfoItem-module__gap-26___tWdG6`,
	"gap30": `CGMInfoItem-module__gap-30____vByp`,
	"gap32": `CGMInfoItem-module__gap-32___L6kTu`,
	"gap40": `CGMInfoItem-module__gap-40___y2qZo`,
	"gap50": `CGMInfoItem-module__gap-50___bd8nq`,
	"flex1": `CGMInfoItem-module__flex-1___NSGHb`,
	"flexNone": `CGMInfoItem-module__flex-none___BgEhq`,
	"flexColumn": `CGMInfoItem-module__flex-column___j1T5H`,
	"flexRow": `CGMInfoItem-module__flex-row___gDLQ0`,
	"verticallyCentered": `CGMInfoItem-module__vertically-centered___cN6nw`,
	"horizontallyCentered": `CGMInfoItem-module__horizontally-centered___moAsh`,
	"horizontallyEnd": `CGMInfoItem-module__horizontally-end___O5AgL`,
	"verticallyStart": `CGMInfoItem-module__vertically-start___Hi19K`,
	"spaceBetween": `CGMInfoItem-module__space-between___w19tk`,
	"flexWrap": `CGMInfoItem-module__flex-wrap___JZZYW`,
	"height100": `CGMInfoItem-module__height-100___Qw8zy`,
	"width50": `CGMInfoItem-module__width-50____teyt`,
	"width100": `CGMInfoItem-module__width-100___bz6Q1`,
	"cursorPointer": `CGMInfoItem-module__cursor-pointer___oX3FN`,
	"cursorNotAllowed": `CGMInfoItem-module__cursor-not-allowed___S8Zbl`,
	"absoluteCentered": `CGMInfoItem-module__absolute-centered___IkQWl`,
	"absolute": `CGMInfoItem-module__absolute___KgVGG`,
	"relative": `CGMInfoItem-module__relative___skScp`,
	"fixed": `CGMInfoItem-module__fixed___dZSG6`,
	"visible": `CGMInfoItem-module__visible___aliIS`,
	"invisible": `CGMInfoItem-module__invisible___NGUPH`,
	"col90": `CGMInfoItem-module__col-90___YLmOq`,
	"colAuto": `CGMInfoItem-module__col-auto___qUwpQ`,
	"medicalTabs": `CGMInfoItem-module__medical-tabs___whDeS`,
	"medicalTableNew": `CGMInfoItem-module__medical-table-new___TzN_t`,
	"noPagination": `CGMInfoItem-module__no-pagination___XfJCA`,
	"medicalTableEmpty": `CGMInfoItem-module__medical-table-empty___bNXa8`,
	"iconBtn": `CGMInfoItem-module__icon-btn___ZqOuf`,
	"searchIcon": `CGMInfoItem-module__search-icon___vLaNb`,
	"disableSelect": `CGMInfoItem-module__disable-select___sCJnn`,
	"breakWord": `CGMInfoItem-module__break-word___fm4tF`,
	"popupClearBtn": `CGMInfoItem-module__popup-clear-btn___XDLTJ`,
	"scrollMB20": `CGMInfoItem-module__scroll-m-b-20___UTGsi`,
	"wrapper": `CGMInfoItem-module__wrapper___d9Ub6`,
	"title": `CGMInfoItem-module__title___DEvJ9`
};
module.exports = ___CSS_LOADER_EXPORT___;
